import { Component, OnDestroy, OnInit } from '@angular/core';
import { AuthService } from './services/auth.service';
import { MatDialog } from '@angular/material/dialog';
import { ProductoDialogComponent } from './productos/product-dialog/product-dialog.component';
import { SearchDialogComponent } from './shared/search-dialog/search-dialog.component';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Subscription, filter, take } from 'rxjs';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'punto-de-venta';
  isSidenavCollapsed = false;
  isLoggedIn = false;
  isMobileView = false;
  isVendedor = false;
  private authSubscription?: Subscription;
  private breakpointSubscription?: Subscription;

  constructor(
    private authService: AuthService,
    private dialog: MatDialog,
    private breakpointObserver: BreakpointObserver
  ) {}

  ngOnInit(): void {
    // Suscribirse al estado de autenticación
    this.authSubscription = this.authService.isAuthenticated$.subscribe(isAuthenticated => {
      this.isLoggedIn = isAuthenticated;
      if (isAuthenticated) {
        this.checkUserRole();
      }
    });

    // Asegurar que el usuario esté cargado si hay una sesión activa
    // El AuthService.restoreSession() ya intenta cargar el usuario en su constructor,
    // pero aquí nos aseguramos de que esté cargado al iniciar la app
    if (this.authService.isLoggedIn()) {
      // Verificar si el usuario ya está cargado
      const currentUser = this.authService.getCurrentUserSnapshot();
      
      if (!currentUser) {
        // Si hay token pero no hay usuario cargado, cargarlo
        // Esto puede pasar si restoreSession() aún no ha completado
        this.authService.fetchCurrentUser().subscribe({
          next: (user) => {
            this.checkUserRole();
          },
          error: (error) => {
            console.warn('Error al cargar usuario desde app.component:', error);
            // Si hay error 401, limpiar la sesión
            if (error?.status === 401) {
              this.authService.logout();
            }
          }
        });
      } else {
        this.checkUserRole();
      }
    }

    // Suscribirse a cambios de usuario para actualizar el rol
    this.authService.currentUser$.subscribe(() => {
      this.checkUserRole();
    });

    this.breakpointSubscription = this.breakpointObserver
      .observe([Breakpoints.Handset, '(max-width: 959px)'])
      .subscribe(result => {
        this.isMobileView = result.matches;
        if (this.isMobileView) {
          this.isSidenavCollapsed = false;
        }
      });
  }

  ngOnDestroy(): void {
    this.authSubscription?.unsubscribe();
    this.breakpointSubscription?.unsubscribe();
  }

  toggleSidenav(): void {
    this.isSidenavCollapsed = !this.isSidenavCollapsed;
  }
  closeSidenav(): void {
    if (!this.isSidenavCollapsed) {
      this.isSidenavCollapsed = true;
    }
  }
  
  
  logout(): void {
    this.authService.logout();
  }

  openDialog(): void {
    const dialogRef = this.dialog.open(ProductoDialogComponent, {
      width: '600px',
      data: { isEdit: false }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        // Lógica para guardar el nuevo producto
        // console.log('Nuevo producto:', result);
      }
    });
  }

  openSearchDialog(): void {
    const dialogRef = this.dialog.open(SearchDialogComponent, {
      width: '600px',
      maxWidth: '90vw'
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        // El producto seleccionado está en result
        console.log('Producto seleccionado:', result);
      }
    });
  }

  private checkUserRole(): void {
    // Verificar primero si el usuario ya está disponible en el snapshot
    const currentUser = this.authService.getCurrentUserSnapshot();
    
    if (currentUser?.['rol']) {
      // Usuario ya disponible, verificar rol
      const rolNombre = typeof currentUser['rol'] === 'string' 
        ? currentUser['rol'] 
        : currentUser['rol']?.['rol'];
      
      this.isVendedor = rolNombre === 'Vendedor';
    } else {
      // Usuario no disponible aún, esperar a que esté disponible
      this.authService.currentUser$.pipe(take(1)).subscribe(user => {
        if (user?.['rol']) {
          const rolNombre = typeof user['rol'] === 'string' 
            ? user['rol'] 
            : user['rol']?.['rol'];
          
          this.isVendedor = rolNombre === 'Vendedor';
        }
      });
    }
  }
}